module.exports = __webpack_public_path__ + "img/sintesis.1bb33dd3.svg";